export default [
   'and',
   'at',
   'by',
   'in',
   'of',
   'or',
   'to',
   'with'
]
